// extracted by mini-css-extract-plugin
export default {"HeatmapCellDividers":"HeatmapCellDividers--d4Lu5"};